import script from "./loghistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./loghistory.vue?vue&type=script&setup=true&lang=ts"

import "./loghistory.vue?vue&type=style&index=0&id=fd4dbce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd4dbce0"]])

export default __exports__